module.exports = __webpack_public_path__ + "img/ic_chevron-up.a6693c91.svg";